import { TaggingSettingsActionType } from '@tagging/actions/taggingSettingsActions';
import { TAGGING_SETTINGS_ACTION_TYPES } from '@tagging/constants/taggingConstants';
import { ITaggingSettingsState, LandingPageType } from '@tagging/models/taggingModels';

const initialState: ITaggingSettingsState = {
  settings: {
    headline: undefined,
    staticLandingPageUrl: undefined,
    dynamicLandingPageUrl: undefined,
    landingPageType: LandingPageType.DynamicLandingPage,
  },
  isFirstRun: false,
  dynamicLandingPageSiteName: undefined,
  isSettingsModalOpen: false,
  isFetchingSettings: false,
  isFetchingDynamicLandingPageSiteName: false,
  hasFetchedSettingsOnce: false,
  isSavingSettings: false,
};

export default function TaggingSettingsReducer(
  state: ITaggingSettingsState = initialState,
  action: TaggingSettingsActionType,
): ITaggingSettingsState {
  switch (action.type) {
    case TAGGING_SETTINGS_ACTION_TYPES.REQUEST_SETTINGS: {
      return {
        ...state,
        isFetchingSettings: true,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.RECEIVE_SETTINGS_SUCCEEDED: {
      return {
        ...state,
        isFirstRun: action.isFirstRun,
        settings: {
          ...state.settings,
          ...action.settings,
          // Fallback to a DynamicLandingPage as the default
          landingPageType: action.settings && action.settings.landingPageType || LandingPageType.DynamicLandingPage,
        },
        ...(action.settings && action.settings.jobStatus && {
          jobStatus: action.settings.jobStatus,
        }),
        isFetchingSettings: false,
        hasFetchedSettingsOnce: true,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.RECEIVE_SETTINGS_FAILED: {
      return {
        ...state,
        isFetchingSettings: false,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.REQUEST_DYNAMIC_LANDING_PAGE_SITE_NAME: {
      return {
        ...state,
        isFetchingDynamicLandingPageSiteName: true,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.RECEIVE_DYNAMIC_LANDING_PAGE_SITE_NAME_SUCCEEDED: {
      return {
        ...state,
        dynamicLandingPageSiteName: action.dynamicLandingPageSiteName,
        isFetchingDynamicLandingPageSiteName: false,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.RECEIVE_DYNAMIC_LANDING_PAGE_SITE_NAME_FAILED: {
      return {
        ...state,
        isFetchingDynamicLandingPageSiteName: false,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.OPEN_SETTINGS_MODAL: {
      return {
        ...state,
        isSettingsModalOpen: true,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.CLOSE_SETTINGS_MODAL: {
      return {
        ...state,
        isSettingsModalOpen: false,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.UPDATE_HEADLINE: {
      return {
        ...state,
        settings: {
          ...state.settings,
          headline: action.headline,
        },
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.UPDATE_LANDING_PAGE_TYPE: {
      return {
        ...state,
        settings: {
          ...state.settings,
          landingPageType: action.landingPageType,
        },
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.UPDATE_STATIC_LANDING_PAGE_URL: {
      return {
        ...state,
        settings: {
          ...state.settings,
          staticLandingPageUrl: action.landingPageUrl,
        },
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.UPDATE_DYNAMIC_LANDING_PAGE_URL: {
      return {
        ...state,
        settings: {
          ...state.settings,
          dynamicLandingPageUrl: action.landingPageUrl,
        },
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.SAVE_SETTINGS: {
      return {
        ...state,
        isSavingSettings: true,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.SAVE_SETTINGS_SUCCEEDED: {
      return {
        ...state,
        settings: {
          ...state.settings,
        },
        isFirstRun: false,
        isSavingSettings: false,
      };
    }
    case TAGGING_SETTINGS_ACTION_TYPES.SAVE_SETTINGS_FAILED: {
      return {
        ...state,
        isSavingSettings: false,
      };
    }
    default:
      return state;
  }
}
